import React from 'react'
import _ from 'lodash'
import PropTypes from 'prop-types'
import { Dropdown } from '@adc/ui-core'
import classnames from 'classnames/bind'
import Breadcrumb from '../breadcrumb'
import styles from './styles.scss'
const cx = classnames.bind(styles)

const PageHeader = props => {
  const {
    crumbs,
    crumbsFullWidth = true,
    buttons,
    title,
    subheader,
    showButtonsAsDropdown,
    dropdownButtonOptions,
    loading,
    titleAllowOverflow = false,
  } = props
  const breadCrumbRender = () =>
    !!crumbs && <Breadcrumb className={cx('breadcrumb')} crumbs={crumbs} />
  const titleRender = () => (
    <div className={cx('title-container')}>
      <h1
        data-elm-id='page_header_title'
        className={cx('title', {
          'title--overflow-visible': titleAllowOverflow,
        })}
      >
        {title}
      </h1>
    </div>
  )
  const buttonRender = () =>
    !!buttons && (
      <div className={cx('button-container')}>
        {showButtonsAsDropdown && !_.isEmpty(dropdownButtonOptions) && (
          <Dropdown
            compact
            data-elm-id='dropdown_button_options'
            text='Actions'
            options={dropdownButtonOptions}
            loading={loading}
            disabled={loading}
            className={`${cx('dropdown-button')} selection`}
          />
        )}
        {(showButtonsAsDropdown
          ? [_.last(buttons.filter(Boolean))]
          : buttons
        ).map((button, index) => (
          <div key={index}>{button}</div>
        ))}
      </div>
    )
  return (
    <div className={cx('page-header')}>
      <>
        {crumbsFullWidth ? (
          <>
            <div className={cx('row-container')}>{breadCrumbRender()}</div>
            <div className={cx('row-container')}>
              {titleRender()}
              {buttonRender()}
            </div>
          </>
        ) : (
          <div className={cx('row-container')}>
            <div className={cx('col-container')}>
              {breadCrumbRender()}
              {titleRender()}
            </div>
            {buttonRender()}
          </div>
        )}
        <div
          data-elm-id='page_header_subheader'
          className={cx('row-container')}
        >
          {subheader}
        </div>
      </>
    </div>
  )
}

PageHeader.propTypes = {
  title: PropTypes.node.isRequired,
  crumbs: PropTypes.array,
  crumbsFullWidth: PropTypes.bool,
  buttons: PropTypes.array,
  subheader: PropTypes.any,
  showButtonsAsDropdown: PropTypes.bool,
  loading: PropTypes.bool,
  dropdownButtonOptions: PropTypes.array,
  // Opt out of the title's overflow:hidden clipping so an interactive title
  // (e.g. a dropdown/popover) can render outside the header. Default keeps the
  // ellipsis truncation used for plain string titles.
  titleAllowOverflow: PropTypes.bool,
}

export default PageHeader
